<template>
  <UiExpandedBlock
    v-model="isOpen"
    class="border-t py-6 max-md:px-4"
    :class="[
      { 'max-md:bg-off-white-10': isOpen },
      isOpen
        ? 'border-t-off-white-10 md:border-t-gray-30'
        : 'border-t-off-white-30 md:border-t-gray-30',
    ]"
  >
    <template #activator="{ attrs }">
      <button
        class="flex w-full items-center justify-between text-primary"
        :class="[isOpen ? 'font-bold' : '']"
        v-bind="attrs"
      >
        <p class="text-sm capitalize">{{ title }}</p>
        <UiIcon
          name="chevron_up"
          class="w-6 transition"
          :class="[isOpen ? '' : 'rotate-180']"
        />
      </button>
    </template>
    <template #content>
      <slot>
        <div v-if="content" v-html="content" />
      </slot>
    </template>
  </UiExpandedBlock>
</template>

<script setup lang="ts">
const props = defineProps<{
  title: string;
  open?: boolean;
  content?: string;
}>();

const isOpen = ref(props.open);
</script>
